import type { Grosze } from "./money.ts";

/**
 * Oznaczenia stawek jak na drukarkach fiskalnych (A–G). Faktyczne przypisanie
 * liter do stawek jest zaprogramowane w drukarce — sterownik fiskalny musi je
 * porównać z odczytem z urządzenia przed pierwszym paragonem.
 */
export type VatCode = "A" | "B" | "C" | "D" | "E" | "F" | "G";
export const VAT_CODES: VatCode[] = ["A", "B", "C", "D", "E", "F", "G"];

export interface VatRate {
  code: VatCode;
  /** Stawka w procentach; null = zwolnione / nie podlega. */
  percent: number | null;
  label: string;
}

export const DEFAULT_VAT_RATES: VatRate[] = [
  { code: "A", percent: 23, label: "23%" },
  { code: "B", percent: 8, label: "8%" },
  { code: "C", percent: 5, label: "5%" },
  { code: "D", percent: 0, label: "0%" },
  { code: "E", percent: null, label: "zw." },
];

/** Kwota VAT zawarta w kwocie brutto (metoda „od brutto”, zaokrąglenie do grosza). */
export function vatFromGross(gross: Grosze, percent: number | null): Grosze {
  if (!percent) return 0;
  return Math.round((gross * percent) / (100 + percent));
}
